<template>
    <div>
        <!-- Common main element parameters -->
        <div v-for="parameter in app.currentConfiguration.commonMainElementParameters"
            style="border: 0px solid black; background-color:white" :key="parameter.attribute.id" class="p-3">
            <editParameterValueComponent ref="editParameterValueComponent" :labelOverInput="true" :parameter="parameter"
                :value.sync="parameter.value" @update:value="refreshParameters"></editParameterValueComponent>
        </div>

        <!-- ELEMENTS -->
        <mainElement68component v-for="(mainElementParameters, key, index) in this.app
            .currentConfiguration.mainElementParameters" :key="key" :main-element="mainElementParameters"
            :main-element-index="key"
            @removeElement="removeElement(key)"
            @refreshParameters="refreshParameters()"
            :sol-constructiva="solConstructiva">
        </mainElement68component>

        <!-- ADD BUTTON -->
        <button @click="app.multiLevelHelper.addElement()" class="btn btn-outline-dark btn_rounded mt-5">
            <i class="fas fa-plus fa-sm"></i>
        </button>
    </div>
</template>
<script>
import { app } from "../../application.js";
import mainElement68component from './mainElement68.vue';
import editParameterValueComponent from "./../editParameterValue.vue";

export default {
    name: 'mainElements68',

    components: {
        mainElement68component,
        editParameterValueComponent
    },

    data() {
        return {
            app: app,
            multiLevel: app.multiLevelHelper,
        }
    },
    computed: {
        solConstructiva: function () {
            return this.app.currentConfiguration.familyParameters["sol_constructiva"].value.id;
        }
    },
    methods: {
        async refreshParameters() {
            await app.asyncProcess(false, false);
        },
        async removeElement(index){
            var self = this;

            this.$nextTick(async () => {
                app.multiLevelHelper.removeElement(index)
            })

            this.$forceUpdate()

            await app.asyncProcess(false, false);
        }
    }
}
</script>